import Menu from 'components/Menu'
import RoundyContainer from 'components/RoundyContainer'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { storageData } from 'services/Services'
import VehicleProgressBreadCrumb from 'components/StraightThroughVehicleComp/VehicleProgressBreadCrumb'
import { RemoveVehicleContext, RemoveVehicleContextComp } from 'components/StraightThroughVehicleComp/RemoveVehicleContext/RemoveVehicleContext'
import ConfirmRemoveVehicleMain from 'components/StraightThroughVehicleComp/VehicleMain_Remove/ConfirmRemoveVehicleMain'

const ConfirmRemoveVehicle = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementRemoveVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <RemoveVehicleContextComp>
                <Menu Title={"REMOVE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <VehicleProgressBreadCrumb screen={"Confirm"} requestContext={RemoveVehicleContext} endorsementType={"RemoveVehicle"} />
                <RoundyContainer Content={ConfirmRemoveVehicleMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </RemoveVehicleContextComp>
        </>
    )
}

export default ConfirmRemoveVehicle